module.exports = __webpack_public_path__ + "static/media/broken-robot.b216aaee.png";